module.exports = __webpack_public_path__ + "images/city_s.296f36f366dbdb30c198d8436c21d722.png";